function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

var DropdownBlockLink =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DropdownBlockLink, _React$Component);

  function DropdownBlockLink() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, DropdownBlockLink);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DropdownBlockLink)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "onClick", function () {
      _this.props.onClick();
    });

    return _this;
  }

  _createClass(DropdownBlockLink, [{
    key: "render",
    value: function render() {
      var styleProps = {};

      if (this.props.minWidth) {
        styleProps.minWidth = this.props.minWidth;
      }

      return React.createElement("div", _extends({
        className: classNames({
          'link': this.props.isLink,
          'isSelected': !this.props.isLink,
          'oui-dropdown__block-link': this.props.isLink
        }),
        style: styleProps
      }, this.props.testSection ? {
        'data-test-section': this.props.testSection
      } : {}, this.props.trackId ? {
        'data-track-id': this.props.trackId
      } : {}, {
        onClick: this.onClick
      }), this.props.children);
    }
  }]);

  return DropdownBlockLink;
}(React.Component);

_defineProperty(DropdownBlockLink, "defaultProps", {
  isLink: true
});

_defineProperty(DropdownBlockLink, "propTypes", {
  /** Content to be shown in the menu option */
  children: PropTypes.node.isRequired,

  /** should this be a link or nonclickable text */
  isLink: PropTypes.bool.isRequired,

  /** Minimum width of the list item, useful if
    * you need to have a block of description text */
  minWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /** Click handler for the menu option */
  onClick: PropTypes.func.isRequired,

  /** Used for data-test-section attribute on the link */
  testSection: PropTypes.string,

  /** Used for data-track-id attribute on the link */
  trackId: PropTypes.string
});

export { DropdownBlockLink as default };